import React from 'react';

const TermsPage: React.FC = () => (
  <div className="min-h-screen bg-black text-white p-6 max-w-3xl mx-auto">
    <h1 className="text-3xl font-bold text-gold mb-4">Termos de Uso</h1>
    <p className="mb-4">Ao acessar o Anuário AMS, você concorda com os seguintes termos:</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Uso Permitido</h2>
    <p>O anuário é destinado apenas para fins informativos e comemorativos. É proibido copiar, distribuir ou modificar o conteúdo sem autorização.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Direitos Autorais</h2>
    <p>Todo o conteúdo, incluindo fotos, textos e depoimentos, pertence aos participantes e à organização do anuário. O uso indevido pode resultar em medidas legais.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Alterações</h2>
    <p>Os termos podem ser atualizados a qualquer momento. Recomenda-se revisar esta página periodicamente.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Contato</h2>
    <p>Para dúvidas sobre os termos, envie um e-mail para anuario@ams.com.</p>
  </div>
);

export default TermsPage;
